import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import RequestService from "@/pages/RequestService";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";
import CancellationPolicy from "@/pages/policies/CancellationPolicy";
import PaymentPolicy from "@/pages/policies/PaymentPolicy";
import PrivacyPolicy from "@/pages/policies/PrivacyPolicy";
import TermsOfService from "@/pages/policies/TermsOfService";
import StaffPortal from "@/pages/StaffPortal";
import LeadWorkspace from "@/pages/LeadWorkspace";
import AssistantPage from "@/pages/AssistantPage";
import RefundRequest from "@/pages/RefundRequest";
import { AiContextProvider } from "@/lib/aiContext";
import AdminGoogleCallback from "@/pages/AdminGoogleCallback";

// Deep-link helpers — preserve query params when redirecting into the
// /admin tab-based router shell.
const RedirectToAdmin = ({ tab }) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set("tab", tab);
  return <Navigate to={`/admin?${params.toString()}`} replace />;
};

function AppRoutes() {
  const location = useLocation();
  // Emergent Google sign-in returns to /admin#session_id=... — exchange it first.
  if (location.hash?.includes("session_id=")) return <AdminGoogleCallback />;
  return (
          <Routes>
            <Route path="/" element={<RequestService />} />
            <Route path="/refund-request" element={<RefundRequest />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/assistant" element={<AssistantPage />} />
            <Route path="/admin/leads" element={<RedirectToAdmin tab="consumer" />} />
            <Route path="/admin/refunds" element={<RedirectToAdmin tab="refunds" />} />
            <Route path="/admin/leads/:leadId" element={<LeadWorkspace />} />
            <Route path="/staff/:token" element={<StaffPortal />} />
            <Route path="/cancellation-policy" element={<CancellationPolicy />} />
            <Route path="/payment-policy" element={<PaymentPolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AiContextProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AiContextProvider>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
